var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "cta",
          rawName: "v-cta",
          value: _vm.isVCtaDirectiveEnabled,
          expression: "isVCtaDirectiveEnabled",
        },
      ],
      staticClass: "rb-banner",
      class: _vm.modifierClasses,
      attrs: { id: _vm.id },
      on: {
        mouseenter: _vm.onMouseEnter,
        mouseleave: _vm.onMouseLeave,
        focusin: _vm.onMouseEnter,
        focusout: _vm.onMouseLeave,
      },
    },
    [
      _vm.isSkeletonVisible
        ? [
            _c("div", { staticClass: "skeleton skeleton-copy-container" }, [
              _vm.isTitleAvailable
                ? _c("div", { staticClass: "sk-title" }, [
                    _c("span", { staticClass: "dummy-text" }),
                    _vm._v(" "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isExcerptAvailable
                ? _c("div", { staticClass: "sk-excerpt" }, [
                    _c("span", { staticClass: "dummy-text" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "dummy-text" }),
                    _vm._v(" \n      "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sk-cta" },
                _vm._l(_vm.ctasAvailable, function (cta, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "dummy-block rb-btn" },
                    [_vm._v("\n           \n        ")]
                  )
                }),
                0
              ),
            ]),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isMediaAvailable
        ? _c(
            "div",
            {
              staticClass: "rb-banner__media-container",
              style: _vm.getDynamicStyle,
            },
            [
              _vm.isPillAvailable
                ? _c(
                    "div",
                    {
                      staticClass: "rb-banner__pill-container",
                      class: _vm.pillModifierClasses,
                    },
                    [
                      _c(
                        "rb-pill",
                        {
                          attrs: {
                            size: "small",
                            color: _vm.pillColorClass,
                            cursor: _vm.pillCursor,
                          },
                        },
                        [
                          _vm.isPillIconOnTheLeft
                            ? [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "common__icon common__icon--small",
                                    class: _vm.getPillIconClass,
                                  },
                                  [_vm._v("pillIcon")]
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(
                            "\n        " + _vm._s(_vm.pill) + "\n        "
                          ),
                          _vm.isPillIconOnTheRight
                            ? [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "common__icon common__icon--small",
                                    class: _vm.getPillIconClass,
                                  },
                                  [_vm._v("pillIcon")]
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isImageAvailable && !_vm.isDummyBanner
                ? [
                    _vm.isLazyLoadEnabled
                      ? _c("picture", { staticClass: "rb-banner__image" }, [
                          _vm.imageMobile
                            ? _c("source", {
                                key: "mobile-image",
                                attrs: {
                                  "data-srcset": _vm.imageMobile,
                                  media: "(max-width: 599px)",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.imageTablet
                            ? _c("source", {
                                key: "tablet-image",
                                attrs: {
                                  "data-srcset": _vm.imageTablet,
                                  media: "(max-width: 1023px)",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("img", {
                            key: "desktop-image",
                            attrs: {
                              fetchpriority: _vm.getFetchPriority,
                              "data-src": _vm.getImageDesktop,
                              alt: _vm.imageAlt,
                            },
                          }),
                        ])
                      : !_vm.isDummyBanner
                      ? _c("picture", { staticClass: "rb-banner__image" }, [
                          _vm.imageMobile
                            ? _c("source", {
                                key: "mobile-image",
                                attrs: {
                                  srcset: _vm.imageMobile,
                                  media: "(max-width: 599px)",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.imageTablet
                            ? _c("source", {
                                key: "tablet-image",
                                attrs: {
                                  srcset: _vm.imageTablet,
                                  media: "(max-width: 1023px)",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("img", {
                            key: "desktop-image",
                            attrs: {
                              fetchpriority: _vm.getFetchPriority,
                              src: _vm.getImageDesktop,
                              alt: _vm.imageAlt,
                            },
                          }),
                        ])
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.isVideoAvailable && !_vm.isDummyBanner
                ? [
                    _c("div", { staticClass: "rb-banner__video" }, [
                      _c(
                        "video",
                        {
                          key: _vm.getVideoKey,
                          ref: "video",
                          attrs: {
                            preload: "metadata",
                            playsinline: "",
                            loop: _vm.loop,
                            "data-poster": _vm.getVideoCover,
                            crossorigin: _vm.videoTranscript
                              ? "anonymous"
                              : false,
                          },
                          domProps: { muted: _vm.isMuted },
                        },
                        [
                          _vm.mobileVideoSource && _vm.isMobile
                            ? _c("source", {
                                attrs: {
                                  "data-src": _vm.mobileVideoSource,
                                  type: "video/mp4",
                                },
                              })
                            : [
                                _vm.videoSource
                                  ? _c("source", {
                                      attrs: {
                                        "data-src": _vm.videoSource,
                                        type: "video/mp4",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                          _vm._v(" "),
                          _vm.videoTranscript
                            ? _c("track", {
                                attrs: {
                                  kind: "captions",
                                  src: _vm.videoTranscript,
                                  default: "",
                                },
                              })
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.isControlAvailable
                        ? _c(
                            "div",
                            {
                              staticClass: "rb-banner__video-controls",
                              class: _vm.videoControlsModifierClasses,
                            },
                            [
                              !_vm.playing
                                ? _c(
                                    "button",
                                    {
                                      attrs: {
                                        type: "button",
                                        "data-element-id": "X_Pdp_Video_Play",
                                        "data-description": _vm.videoName,
                                        "aria-controls": "play",
                                        "aria-label": "play",
                                      },
                                      on: {
                                        click: _vm.play,
                                        keypress: _vm.onPlayKeypress,
                                      },
                                    },
                                    [
                                      _c("rb-lazy-icon", {
                                        attrs: {
                                          icon: "vp-play-round",
                                          text: "play",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.playing
                                ? _c(
                                    "button",
                                    {
                                      attrs: {
                                        type: "button",
                                        "data-element-id": "X_Pdp_Video_Pause",
                                        "data-description": _vm.videoName,
                                        "aria-controls": "pause",
                                        "aria-label": "pause",
                                      },
                                      on: {
                                        click: _vm.pause,
                                        keypress: _vm.onPauseKeypress,
                                      },
                                    },
                                    [
                                      _c("rb-lazy-icon", {
                                        attrs: {
                                          icon: "vp-pause-round",
                                          text: "pause",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.audioTogglesEnabled && _vm.isMuted
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn-audio",
                                      attrs: {
                                        type: "button",
                                        "data-element-id": "X_Pdp_Video_Audio",
                                        "data-description": _vm.videoName,
                                        "aria-controls": "audio toggle",
                                        "aria-label": "audio toggle",
                                      },
                                      on: {
                                        click: _vm.toggleAudio,
                                        keypress: _vm.onToggleAudioKeypress,
                                      },
                                    },
                                    [
                                      _c("rb-lazy-icon", {
                                        attrs: {
                                          icon: "vp-audio-off",
                                          text: "audio toggle",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.audioTogglesEnabled && !_vm.isMuted
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn-audio",
                                      attrs: {
                                        type: "button",
                                        "data-element-id": "X_Pdp_Video_Audio",
                                        "aria-controls": "vp-audio",
                                        "aria-label": "vp-audio",
                                        "data-description": _vm.videoName,
                                      },
                                      on: {
                                        click: _vm.toggleAudio,
                                        keypress: _vm.onToggleAudioKeypress,
                                      },
                                    },
                                    [
                                      _c("rb-lazy-icon", {
                                        attrs: {
                                          icon: "vp-audio",
                                          text: "vp-audio",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.isVideoEmbeddedAvailable
                ? _c(
                    "div",
                    { staticClass: "rb-banner__embedded-video" },
                    [
                      _c("rb-embedded-video", {
                        attrs: { type: _vm.type, "video-id": _vm.videoId },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          )
        : !_vm.isMediaAvailable && _vm.isWithNoImageBg
        ? _c("div", { staticClass: "rb-banner__media-container --empty" })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isSkeletonVisible
        ? _c(
            "div",
            {
              staticClass: "rb-banner__copy-container",
              class: { "with-countdown": _vm.countdownStart },
            },
            [
              _c(
                "rb-text-module",
                _vm._b(
                  {
                    class: "m-dynamic--" + _vm.dynamicMargin,
                    attrs: {
                      "message-color": _vm.textModuleMessageColor,
                      "heading-tag": _vm.headingTag,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "image",
                          fn: function () {
                            return [_vm._t("image")]
                          },
                          proxy: true,
                        },
                        {
                          key: "image_block",
                          fn: function () {
                            return [_vm._t("image_block")]
                          },
                          proxy: true,
                        },
                        {
                          key: "message",
                          fn: function () {
                            return [_vm._t("message")]
                          },
                          proxy: true,
                        },
                        {
                          key: "title",
                          fn: function () {
                            return [_vm._t("title")]
                          },
                          proxy: true,
                        },
                        {
                          key: "title_block",
                          fn: function () {
                            return [_vm._t("title_block")]
                          },
                          proxy: true,
                        },
                        {
                          key: "excerpt",
                          fn: function () {
                            return [_vm._t("excerpt")]
                          },
                          proxy: true,
                        },
                        {
                          key: "excerpt_block",
                          fn: function () {
                            return [_vm._t("excerpt_block")]
                          },
                          proxy: true,
                        },
                        {
                          key: "subtitle",
                          fn: function () {
                            return [_vm._t("subtitle")]
                          },
                          proxy: true,
                        },
                        {
                          key: "subtitle_block",
                          fn: function () {
                            return [_vm._t("subtitle_block")]
                          },
                          proxy: true,
                        },
                        {
                          key: "cta_1",
                          fn: function () {
                            return [_vm._t("cta_1")]
                          },
                          proxy: true,
                        },
                        {
                          key: "cta_2",
                          fn: function () {
                            return [_vm._t("cta_2")]
                          },
                          proxy: true,
                        },
                        {
                          key: "cta_block",
                          fn: function () {
                            return [_vm._t("cta_block")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  "rb-text-module",
                  _vm.copyProps,
                  false
                )
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }